import { forwardRef, TextareaHTMLAttributes } from 'react';
import { cn } from './cn';
import { Label } from './label';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className, id, ...props }, ref) => {
    const field = (
      <textarea
        ref={ref}
        id={id}
        className={cn(
          'flex min-h-[4.5rem] w-full rounded-lg border border-nova-input bg-transparent px-2.5 py-1.5 text-sm text-nova-foreground',
          'placeholder:text-nova-muted-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nova-ring/30',
          'disabled:cursor-not-allowed disabled:opacity-50',
          error && 'border-red-500 focus-visible:ring-red-500/30',
          className
        )}
        {...props}
      />
    );

    if (!label && !error) return field;

    return (
      <div className="w-full">
        {label ? (
          <Label htmlFor={id} className="mb-1.5 block">
            {label}
          </Label>
        ) : null}
        {field}
        {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
